$(document).ready(function () {
    let activeShop = null;
    const $shopPopup = $("#shopPopup");
    const $parentDiv = $("#shops-map-container");
    const $mapSelectors = $(".map-selector");
    const $shopPopupClose = $(".shopPopup_close");
    let activeBase = null;
  
    function updateShopLink(baseLink) {
      if (!baseLink) return;
      var link = baseLink;
      if (document.cookie.includes("PopupHidden=")) {
        link += (link.includes("?") ? "&" : "?") + "locationApproved=true";
      }
      let query = window.location.search;
      let utmParams = query.match(/utm_[^&=]+=[^&]+/gi);
      if (utmParams && utmParams.length > 0) {
        link += (link.includes("?") ? "&" : "?") + utmParams.join("&");
      }
      return link;
    }
  
    // Calculates marker center position relative to parent
    function calculateRelativePosition(child) {
      const parentRect = $parentDiv[0].getBoundingClientRect();
      const childRect = child.getBoundingClientRect();
      const $circle = $(child).find("circle").last();
      // const r = $circle.length ? parseFloat($circle.attr("r")) : 0;
      return {
        x: childRect.left - parentRect.left,
        y: childRect.top - parentRect.top,
      };
    }
  
    // Updates popup position & keeps it inside parent bounds
    function updatePopupPosition() {
      if (!activeShop) return;
  
      const wasHidden = $shopPopup.css("display") === "none";
      if (wasHidden) {
        $shopPopup.css({
          display: "flex",
          position: "absolute",
          visibility: "hidden",
        });
      }
  
      const { x: relativeX, y: relativeY } =
        calculateRelativePosition(activeShop);
      const popupRect = $shopPopup[0].getBoundingClientRect();
      const parentRect = $parentDiv[0].getBoundingClientRect();
  
      const MARGIN = 15;
      const minLeft = MARGIN;
      const maxLeft = parentRect.width - popupRect.width - MARGIN;
      const minTop = MARGIN;
      const maxTop = parentRect.height - popupRect.height - MARGIN;
      let finalX = Math.min(Math.max(relativeX, minLeft), maxLeft);
      let finalY = Math.min(Math.max(relativeY, minTop), maxTop);
  
      finalX = Math.round(finalX);
      finalY = Math.round(finalY);
  
      $shopPopup.css({
        left: finalX + "px",
        top: finalY + "px",
        position: "absolute",
        display: "flex",
        visibility: "visible",
      });
    }
  
    // Shows popup and fills in shop data
    function showPopup(shopData) {
      shopData.shopLink = updateShopLink(shopData.shopLink);
      $shopPopup
        .find("#shopName")
        .text(shopData.shopName)
        .end()
        .find("#shopDetails")
        .text(shopData.shopDetails)
        .end()
        .find("#shopImage")
        .attr("src", shopData.shopImage)
        .end()
        .find("#shopLink")
        .attr("href", shopData.shopLink)
        .end()
        .find("#shopLink .map-shop-popup__link-text")
        .text(shopData.shopLinkText);
  
      setTimeout(updatePopupPosition, 0);
  
      $("#shopImage")
        .one("load", updatePopupPosition)
        .each(function () {
          if (this.complete) $(this).trigger("load");
        });
    }
  
    // Hides popup and removes active states
    function hidePopup(keepHover = false) {
      $shopPopup.css("display", "none");
      $mapSelectors.removeClass("active");
      $('#shops-map-container [id$="_map"]').removeClass("active");
  
      if (!keepHover) {
        $mapSelectors.removeClass("hover");
        $('#shops-map-container [id$="_map"]').removeClass("hover");
      }
  
      activeShop = null;
    }
  
    // Handles click on a map marker
    $mapSelectors.on("click", function () {
      const id = this.id;
      const base = id.replace(/_(data|map)$/i, "");
      const targetId = `${base}_map`;
      const dataId = `${base}_data`;
      const newActive = document.getElementById(dataId);
  
      if (activeShop === newActive && $shopPopup.is(":visible")) {
        hidePopup(true);
        return;
      }
  
      hidePopup(true);
  
      $mapSelectors.removeClass("active");
      $('#shops-map-container [id$="_map"]').removeClass("active");
  
      $("#" + dataId).addClass("active");
      $("#" + targetId).addClass("active");
  
      activeShop = newActive;
  
      const shopData = {
        shopName: $("#" + dataId).data("shop-name"),
        shopDetails: $("#" + dataId).data("shop-details"),
        shopImage: $("#" + dataId).data("shop-image"),
        shopLink: $("#" + dataId).data("shop-link"),
        shopLinkText: $("#" + dataId).data("link-title"),
      };
  
      setTimeout(() => showPopup(shopData), 0);
    });
  
    $(document).on("click", function (e) {
      if (
        $(e.target).closest(".map-shop-popup").length ||
        $(e.target).closest(".map-selector").length ||
        $(e.target).closest(".country-map").length
      ) {
        return;
      }
      hidePopup(false);
    });
  
    //Handles click on a country map
    $(".country-map").on("click", function () {
      const id = this.id;
      const base = id.replace(/_(data|map)$/i, "");
      const targetId = `${base}_data`;
      const newActive = document.getElementById(targetId);
  
      if (activeShop === newActive && $shopPopup.is(":visible")) {
        hidePopup(true);
        return;
      }
  
      hidePopup(true);
  
      $mapSelectors.removeClass("active");
      $('#shops-map-container [id$="_map"]').removeClass("active");
  
      $(this).addClass("active");
      $("#" + targetId).addClass("active");
  
      activeShop = newActive;
  
      const shopData = {
        shopName: $("#" + targetId).data("shop-name"),
        shopDetails: $("#" + targetId).data("shop-details"),
        shopImage: $("#" + targetId).data("shop-image"),
        shopLink: $("#" + targetId).data("shop-link"),
        shopLinkText: $("#" + targetId).data("link-title"),
      };
  
      setTimeout(() => showPopup(shopData), 0);
    });
  
    //DESKTOP: hover animation
    if ($(window).width() >= 678) {
      $(".country-map, .map-selector").on("mouseenter", function () {
        const base = this.id.replace(/_(data|map)$/i, "");
        $(".hover").removeClass("hover");
        $("#" + base + "_map").addClass("hover");
        $("#" + base + "_data").addClass("hover");
      });
  
      $(".country-map, .map-selector").on("mouseleave", function (e) {
        if ($(e.relatedTarget).closest(".country-map, .map-selector").length) {
          return;
        }
        $(".hover").removeClass("hover");
      });
    }
  
    // Repositions popup on window resize
    $(window).on("resize", updatePopupPosition);
  
    // Closes map popup
    $shopPopupClose.on("click", hidePopup);
  });
  